import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useToggle, useLocalStorage } from 'react-use';
import { setPage } from 'redux/actions';
import {
  ChartSetPreferenceListModal,
  ChartSetPreferenceFormModal,
  useChartSetPreference,
  DeviceChartConfigModal,
  ChartPreferenceDeleteDialog
} from 'components/features/DeviceChartView';
import ChartExplorerPageHeader from './ChartExplorerPageHeader';
import ChartExplorerPageBody from './ChartExplorerPageBody';
import styles from './ChartExplorerPage.module.css';

const ANNOTATION_ENABLED_KEY = 'annotation.enabled';

function ChartExplorerPage() {
  const { search } = useLocation();
  const [marker] = useLocalStorage(ANNOTATION_ENABLED_KEY, false);
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const deviceId = searchParams.get('deviceId');
  const dispatch = useDispatch();
  const [manageChartSetModalOpened, toggleManageChartSetModalOpened] = useToggle(false);
  const [createChartSetModal, setCreateChartSetModal] = useState(null);
  const [editChartModal, setEditChartModal] = useState(null);
  const [deleteChartModal, setDeleteChartModal] = useState(null);
  const { loaded, loading, data, select, update } = useChartSetPreference();
  const openCreateChartSetModal = useCallback((state) => {
    setCreateChartSetModal(state);
  }, []);
  const closeCreateChartSetModal = useCallback(() => {
    setCreateChartSetModal(null);
  }, []);
  const openEditChartModal = useCallback((state) => {
    setEditChartModal(state);
  }, []);
  const closeEditChartModal = useCallback(() => {
    setEditChartModal(null);
  }, []);
  const openDeleteChartModal = useCallback((state) => {
    setDeleteChartModal(state);
  }, []);
  const closeDeleteChartModal = useCallback(() => {
    setDeleteChartModal(null);
  }, []);

  useEffect(() => {
    dispatch(setPage('ChartExplorerPage'));
  }, [dispatch]);

  return (
    <div className={styles.root}>
      <ChartExplorerPageHeader />
      <ChartExplorerPageBody
        deviceId={deviceId}
        preference={data}
        loaded={loaded}
        loading={loading}
        enabledZoom={true}
        enabledMarker={marker}
        displayAxisTitle={true}
        displayActionAnnotation={true}
        displayUserAnnotation={marker}
        displayDataLabel={marker}
        displayMarker={marker}
        onSelect={select}
        onUpdate={update}
        onCreate={openCreateChartSetModal}
        onManage={toggleManageChartSetModalOpened}
        onEditChart={openEditChartModal}
        onDeleteChart={openDeleteChartModal}
      />
      {manageChartSetModalOpened && <ChartSetPreferenceListModal onClose={toggleManageChartSetModalOpened} />}
      {createChartSetModal != null && (
        <ChartSetPreferenceFormModal {...createChartSetModal} onClose={closeCreateChartSetModal} onSelect={select} />
      )}
      {editChartModal != null && (
        <DeviceChartConfigModal {...editChartModal} width={1100} height={300} onClose={closeEditChartModal} />
      )}
      {deleteChartModal != null && (
        <ChartPreferenceDeleteDialog {...deleteChartModal} onClose={closeDeleteChartModal} />
      )}
    </div>
  );
}

export default ChartExplorerPage;
